import { Route } from '../../../../domain/route/Route';
import { Stop } from '../../../../domain/stop/Stop';
import { RouteActionType, RouteActions } from './actions';

export interface RouteState {
  route?: Route;
  selectedStopId?: string;
  reportStart?: Date;
  startedReportStop?: string;
  editingStop?: Stop;
  nextStopTopScroll: number;
}

export const getInitialState = (): RouteState => ({
  route: undefined,
  selectedStopId: undefined,
  reportStart: undefined,
  editingStop: undefined,
  nextStopTopScroll: 0,
});

export const RouteReducer = (state: RouteState, action: RouteActions): RouteState => {
  switch (action.type) {
    case RouteActionType.FETCH_ROUTE_SUCCESS:
      return {
        ...state,
        route: action.payload,
      };
    case RouteActionType.UPDATE_ROUTE_FAIL: // Is the same as FETCH_ROUTE_SUCCESS, but using that "actionName" feels wrong
      return {
        ...state,
        route: action.payload,
      };
    case RouteActionType.CREATE_DRIVER_SURVEY:
      // TODO: REFACTOR THIS. NO S'HAURIA DE MODIFICAR DIRECTAMENT EL STATE AQUI. S'HAURIA DE CREAR UN NOU ROUTE, SETEJAR-LI
      //  LA SURVEY I POSAR EL NOU ROUTE A L'STATE. NO ES POT FER CLONE DIRECTAMENT PERQUÈ NO TENIM ELS PROJECT CUSTOM FIELDS.
      if (state.route) {
        state.route.survey = action.payload;
      }
      return {
        ...state,
        route: state.route,
      };
    case RouteActionType.SET_SELECTED_STOP:
      return {
        ...state,
        selectedStopId: action.payload,
      };

    case RouteActionType.SET_REPORT_START:
      return {
        ...state,
        reportStart: action.payload?.date,
        startedReportStop: action.payload?.stopId,
      };
    case RouteActionType.SET_EDITING_STOP:
      return {
        ...state,
        editingStop: action.payload,
      };
    case RouteActionType.SET_NEXT_STOP_TOP_SCROLL:
      return {
        ...state,
        nextStopTopScroll: action.payload || 0,
      };
    default:
      return state;
  }
};
